import BaseRepository from '@/baseRepository/BaseRepository';
const resource = `/api/v1/announcements`;
export default {
  getAnnouncements(baseURL, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/today`, {
      baseURL,
      headers,
      params,
    });
  },
};
